import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dot_que_tile = _resolveComponent("dot-que-tile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionList, (item, index) => {
      return (_openBlock(), _createBlock(_component_dot_que_tile, {
        key: index,
        curTime: $props.curTime,
        questionData: item.question_info,
        questionIndex: index,
        onHandleAfterRender: $setup.handleAfterRender
      }, null, 8, ["curTime", "questionData", "questionIndex", "onHandleAfterRender"]))
    }), 128))
  ]))
}